import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { MonedasConstant } from 'constants/index'

import * as TiposCambioService from 'services/tiposCambio.service'

const TipoCambioFormGroup = ({ iFechaValue, iMonedaValue, iError, iTouched, fIsSubmitting, setFieldValue }) => {
  React.useEffect(() => {
    const monedaConsulta = iMonedaValue === MonedasConstant.EUROS ? MonedasConstant.EUROS : MonedasConstant.DOLARES

    TiposCambioService.getxFechaxMonedaxTipoCambio(iFechaValue, monedaConsulta, 'VENT').then(({ data }) => {
      setFieldValue('tipoCambio', data.tipoCambio || 0)
    })
  }, [iFechaValue, iMonedaValue, setFieldValue])

  return (
    <Form.Group>
      <Form.Label text='T/C' htmlFor='input-tipoCambio' md={4} />
      <Col md={8}>
        <Field name='tipoCambio'>
          {({ field }) => <Form.InputNumber {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='input-tipoCambio' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoCambioFormGroup)
